import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { counselorSessionStore } from 'shared/stores/counselorSessionStore'

/**
 * Restricts a route to master/admin counselors (backend is source of truth).
 */
export const AdminRoute = observer(function AdminRoute({ children }) {
	const [ready, setReady] = useState(counselorSessionStore.isLoaded)

	useEffect(() => {
		let alive = true
		counselorSessionStore
			.ensureLoaded()
			.catch(() => {})
			.finally(() => {
				if (alive) setReady(true)
			})
		return () => {
			alive = false
		}
	}, [])

	if (!ready || counselorSessionStore.loadStatus === 'loading') {
		return null
	}

	if (counselorSessionStore.loadStatus === 'error' || !counselorSessionStore.canAccessUserManagement) {
		return <Navigate to="/" replace />
	}

	return children
})

export default AdminRoute
